<template>
    <div class="update-app">
        <brand-backdrop />

        <div class="update-app-content">
            <div class="update-app-logo">
                <span class="update-app-glow"></span>
                <v-img eager contain height="100" class="update-app-logo-img"
                       :src="require('@/assets/img/brand_mark.png')"/>
            </div>

            <div class="update-app-title">{{ $t('common.new_version_available') }}</div>
            <div class="update-app-subtitle">{{ $t('common.update_app_subtitle') }}</div>

            <v-btn
                color="primary" depressed large block
                class="black--text text-none font-weight-bold update-app-btn"
                @click="goToStore">
                <v-icon left size="20">mdi-tray-arrow-down</v-icon>
                {{ $t('common.download') }}
            </v-btn>
        </div>
    </div>
</template>

<script>

import scrollLock from '@/mixins/scrollLock'
import BrandBackdrop from '@/components/common/BrandBackdrop'

export default {
    name: "UpdateApp",
    components: {
        BrandBackdrop,
    },
    mixins: [scrollLock],
    computed: {
        url() {
            const store = this.isIosApp ? process.env.VUE_APP_APPSTORE_URL : process.env.VUE_APP_PLAYSTORE_URL
            return store || null
        },
    },
    methods: {
        goToStore() {
            const vm = this
            if (!vm.url) return
            window.open(vm.url)
        }
    }
}
</script>

<style scoped>

.update-app {
    position: fixed;
    inset: 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #06080C;
    padding: calc(40px + var(--safe-area-inset-top, 0px)) 24px calc(40px + var(--safe-area-inset-bottom, 0px));
    overflow-x: hidden;
    overflow-y: auto;
}

.update-app-content {
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 360px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    animation: update-app-fade-up .5s ease both;
}

.update-app-logo {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 30px;
    animation: update-app-badge-pop .6s cubic-bezier(.34, 1.56, .64, 1) both;
    animation-delay: .12s;
}

.update-app-logo-img {
    position: relative;
    z-index: 1;
    width: 200px;
}

.update-app-glow {
    position: absolute;
    width: 280px;
    height: 280px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(204, 255, 51, 0.24) 0%, rgba(51, 153, 153, 0.14) 45%, transparent 70%);
    filter: blur(8px);
}

@keyframes update-app-fade-up {
    from { opacity: 0; transform: translateY(14px); }
    to { opacity: 1; transform: none; }
}

@keyframes update-app-badge-pop {
    0% { opacity: 0; transform: scale(.7); }
    60% { transform: scale(1.06); }
    100% { opacity: 1; transform: scale(1); }
}

.update-app-title {
    font-size: 32px;
    font-weight: 800;
    letter-spacing: -0.02em;
    line-height: 1.15;
    color: #F2F5FA;
}

.update-app-subtitle {
    font-size: 16px;
    line-height: 1.5;
    color: rgba(242, 245, 250, 0.6);
    margin-top: 12px;
}

.update-app-btn {
    margin-top: 36px;
}

</style>
